import React from "react";

function RulesofPremium() {
  return (
    <>
      <div
        id="sportsBookRulesWrap_1"
        className="overlay"
        style={{ display: "none" }}
      >
        <div className="side-wrap rules-download">
          <div className="side-head">
            <h3 id="sportsbookRulesTitle" className="">
              Rules of Premium Tennis
            </h3>
            <a className="close ui-link" href="/home">
              Close
            </a>
          </div>
          <div className="side-content rules-content">
            <ol id="owTennisRulesContent" style={{ display: "block" }}>
              <li>
                Handicap
                <ul>
                  <li>Set Handicap betting are settle based on the Sets</li>
                  <li>
                    For Tennis Set hdp betting, the player you wager on must
                    cover/beat the set Spread. This means that the favored
                    player must win by more than the outlined number of sets or
                    the underdog will receive that number of sets as a head
                    start. In the above exmaple, If you wager on Andreas Seppi
                    +1.5, he would need to win the match by any score or
                    alternately lose by 1 set. If you wager on Daniil Medvedec
                    -1.5, he would need to win by 2 set .
                  </li>
                  <li>
                    If the scheduled number of sets required to win a match is
                    changed from that originally scheduled then all bets will be
                    void, except for those that have been unconditionally
                    determined.
                  </li>
                  <li>
                    All bets will be consider void if the match is not
                    completed.
                  </li>
                </ul>
              </li>
              <li>
                Over/Under
                <ul>
                  <li>
                    Game Total settle based on the total number of Games played
                    of the match.
                  </li>
                  <li>
                    All bets will be consider void if the match is not
                    completed.
                  </li>
                </ul>
              </li>
              <li>
                Money Line
                <ul>
                  <li>
                    Money line markets refer to the winner of the match or
                    specified set.
                  </li>
                  <li>
                    If a player does not start a tournament or match ,
                    disqualified, retires during the match, then all bets on
                    that player will be void.
                  </li>
                  <li>
                    If a match is postponed or suspended then all bets are still
                    considered valid if the match is completed.
                  </li>
                  <li>
                    All bets will still be considered valid regardless of any
                    change of venue or court surface (including moving matches
                    from outdoor to indoor courts or vice versa).
                  </li>
                  <li>
                    All bets will be consider void if the match is not
                    completed.
                  </li>
                </ul>
              </li>
              <li>
                Game Handicap (Tennis)
                <ul>
                  <li>Game Hdandicap betting are settled based on Games.</li>
                  <li>
                    For Tennis Game Hdp betting , the player you wager on must
                    cover/beat the game spread. This means that the favored
                    player must win by more than the outlined number of games or
                    the underdog will receive that number of games as a head
                    start. In the above example, if you wager on Andreas Seppi
                    +3.5, he would need to win the match by any score or
                    alternately lose by 3 games or less. If you wager on Daniil
                    Medvedev -3.5, he would need to win by 4 games or more.
                  </li>
                  <li>
                    All bets will be consider void if the match is not
                    completed.
                  </li>
                </ul>
              </li>
              <li>
                Set x Winner (Tennis)
                <ul>
                  <li>
                    Set X Winner refers to the result of the specified set. All
                    bets will be considered void if the specified set is not
                    completed.
                  </li>
                </ul>
              </li>
              <li>
                Set x Total Game O/U (Tennis)
                <ul>
                  <li>
                    Set X Total Game O/U refers to total Game of the specified
                    set. All bets will be considered void if the specified set
                    is not completed.
                  </li>
                </ul>
              </li>
            </ol>
            <ol id="owSoccerRulesContent" style={{ display: "none" }}>
              <li>
                FT.1X2:1X2 means betting in any one of three possible winning
                outcomes for an Event. 1 refers to the team that is named first
                (usually the home team); X refers to the game resulting in a
                draw or tie; 2 refers to the team that is named second (usually
                the away team).
              </li>
              <li>
                1H 1X2:1st Half 1X2 means betting in any one of three possible
                winning outcomes of the first half for an Event. 1 refers to the
                team that is named first (usually the home team); X refers to
                the game resulting in a draw or tie; 2 refers to the team that
                is named second (usually the away team).
              </li>
              <li>
                Over/Under: Over/Under means betting that is determined by the
                total number of points (goals, games etc) in the final result of
                an Event. If the total is more than the Over/Under
                pre-designated line then the winning result is Over; if the
                total is less than the Over/Under pre-designated line then the
                winning result is Under.
              </li>
              <li>
                1H Over/Under: 1st Half Over/Under means betting that is
                determined by the total number of points in the result of the
                first half of an Event. If the total is more than the Over/Under
                pre-designated line then the winning result is Over; if the
                total is less than the Over/Under pre-designated line then the
                winning result is Under.
              </li>
              <li>
                Over/Under Guideline:
                <ul>
                  <li>
                    Goal line under 2
                    <div>
                      Bets win if there is either 0 or 1 goal scored in the
                      match. If there are two goals exactly then the stake is
                      returned. Bets lose if there are three or more goals
                      scored in the match.
                    </div>
                  </li>

                  <li>
                    Goal line over 2
                    <div>
                      Bets win if there are three or more goals scored in the
                      match. If there are two goals exactly the stake is
                      returned. Bets lose if there is 0 or 1 goal scored in the
                      match.
                    </div>
                  </li>

                  <li>
                    Goal line under 2.25
                    <div>
                      Bets win if there is either 0 or 1 goal scored in the
                      match. If there are two goals exactly half the stake will
                      win and half will be returned. Bets lose if there are
                      three or more goals scored in the match.
                    </div>
                  </li>
                  <li>
                    Goal line over 2.25
                    <div>
                      Bets win if there are three or more goals scored in the
                      match. If there are two goals exactly half the stake will
                      be returned and half will be lost. Bets lose if there is 0
                      or 1 goal scored in the match.
                    </div>
                  </li>
                  <li>
                    Goal line under 2.5
                    <div>
                      Bets win if there are 0, 1 or 2 goals scored in the match.
                      Bets lose if there are three or more goals scored in the
                      match.
                    </div>
                  </li>
                  <li>
                    Goal line over 2.5
                    <div>
                      Bets win if there are three or more goals scored in the
                      match. Bets lose if there are 0, 1 or 2 goals scored in
                      the match.
                    </div>
                  </li>
                  <li>
                    Goal line under 2.75
                    <div>
                      Bets win if there are 0, 1 or 2 goals scored in the match.
                      If there are three goals exactly half the stake will be
                      returned and half will be lost. Bets lose if there are
                      four or more goals scored in the match.
                    </div>
                  </li>
                  <li>
                    Goal line over 2.75
                    <div>
                      Bets win if there are four or more goals scored in the
                      match. If there are three goals exactly half the stake
                      will win and half will be returned. Bets lose if there are
                      0, 1 or 2 goals scored in the match.
                    </div>
                  </li>
                </ul>
              </li>

              <li>
                Double Chance: The following options are available:
                <ul>
                  <li>
                    1 or X - If the result is either a home or draw then bets on
                    this option are winners.
                  </li>
                  <li>
                    X or 2 - If the result is either a draw or away then bets on
                    this option are winners.
                  </li>
                  <li>
                    1 or 2 - If the result is either a home or away then bets on
                    this option are winners.
                  </li>
                  <li>
                    If a match is played at a neutral venue the team listed
                    first is deemed the home team for betting purposes.
                  </li>
                </ul>
              </li>
              <li>
                Odd/Even: Odd/Even means betting that is determined by whether
                the total number of points (goals, games etc) in the final
                result of an Event is Odd or Even.
              </li>
              <li>
                1H Odd/Even: 1st Half Odd/Even means betting that is determined
                by whether the total number of points at the end of the first
                half of an Event is Odd or Even. 1st half bets will be void if
                an Event is abandoned before the end of the first half. But if
                an Event is abandoned after the end of the first half, all 1st
                half bets will be valid.
              </li>
              <li>
                Handicap: Handicap means betting when one competitor or team
                receives a virtual head start (effectively leading by that head
                start before the Event begins). The winner is the competitor or
                team with the better score after adding the given handicap to
                the result. Remaining Handicap rules are set out in the Specific
                Event Betting Rules.
              </li>
              <li>
                1H Handicap: 1st Half Handicap means betting on the team with
                the better score after adding the given handicap to the result
                of the first half of an Event.
              </li>
              <li>
                Correct Score (AOS) :
                <ul>
                  <li>
                    Correct Score means betting to predict the final score at
                    the end of full-time.
                  </li>
                  <li>
                    First Half Correct Score means betting to predict the final
                    score at the end of First Half.
                  </li>
                  <li>
                    Correct Score to win "AOS" means the selected team must win
                    to a score not listed in the selection.
                  </li>
                  <li>
                    Example:
                    <ul>
                      <li>
                        Result for 5-0UP - 5:1, 6:2 and etc (Lose) / 5:0, 6:1
                        and etc (Win)
                      </li>
                      <li>
                        Result for 0-5UP - 1:5, 2:6 and etc (Lose) / 0:5, 1:6
                        and etc (Win)
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>
              <li>
                E-Soccer bets whenever applicable, are governed by the same
                rules for bets placed on real sporting events. The Company
                provides information (e.g. neutral ground, Red card, timer,
                statistical information, dates, commencement, etc) as a service
                and accepts no liability whatsoever. The timer and red card
                notices are given for reference purposes only.
              </li>
              <li>
                In case there is a technical issue or malfunction in a match,
                all placed bets will be voided and refunded in accordance with
                our general betting rules and regulations.
              </li>
              <li>
                The Company reserves its right to void any bet when it deems
                necessary under the circumstances. The decision of the Company
                with respect to any bet is final.
              </li>
            </ol>
          </div>
          <ul className="btn-list">
            <li>
              <a href="#" className="btn ui-link">
                OK
              </a>
            </li>
          </ul>
        </div>
      </div>
    </>
  );
}

export default RulesofPremium;
